import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Twitter(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.465 4.253a8.445 8.445 0 001.97-1.025 1 1 0 011.542 1.039c-.29 1.325-1.004 2.528-1.886 3.482v.375c0 5.47-2.672 9.472-6.517 11.468-3.817 1.981-8.692 1.936-13.051-.433a1 1 0 01.516-1.878 9.688 9.688 0 004.196-.77c-1.277-.806-2.212-1.752-2.873-2.772-.926-1.43-1.275-2.946-1.338-4.304-.063-1.354.157-2.571.387-3.443.131-.495.284-.995.496-1.463a1 1 0 011.715-.182c1.528 2.064 3.825 3.363 6.38 3.571.035-1.382.608-2.68 1.8-3.646 1.893-1.723 4.8-1.663 6.663-.019zM4.24 6.933c-.15.68-.26 1.516-.22 2.409.051 1.086.327 2.239 1.02 3.31.69 1.065 1.833 2.112 3.721 2.933a1 1 0 01.148 1.755 12.089 12.089 0 01-2.9 1.387c2.726.595 5.424.241 7.643-.91 3.155-1.638 5.438-4.938 5.438-9.693v-.781a1 1 0 01.3-.715c.118-.115.232-.235.34-.358-.096.029-.193.057-.291.083a1 1 0 01-1.016-.314c-1.094-1.27-3.08-1.393-4.29-.274a1.032 1.032 0 01-.055.047C13.33 6.412 13 7.185 13 8.054v.89a1 1 0 01-.973 1 10.76 10.76 0 01-7.786-3.011z",
    clipRule: "evenodd"
  }));
}

export default Twitter;